// extracted by mini-css-extract-plugin
export default {"labelGap":"FormControl_labelGap__TR3yc","label":"FormControl_label__TY-2y"};